import { WalletAddressFormInput } from 'BreetComponents';
import { useUsdWithdrawRequestContext } from 'BreetHooks';

const FormWalletAddressInputs = () => {
	const { formDataContextProps, tokenOptions, walletInfoData, authSettings } = useUsdWithdrawRequestContext();

	return (
		<WalletAddressFormInput
			formDataContextProps={formDataContextProps}
			tokenOptions={tokenOptions}
			walletInfoData={walletInfoData}
			authSettings={authSettings}
		/>
	);
};

export default FormWalletAddressInputs;
